import React, { Component } from 'react';
import DarkThemeNav from '../common/dark-theme-nav';
class SplitPanel extends Component {

  constructor(props) {
    super(props);
    this.state = {
      'smallSplitterVertical': false,
      'smallSplitterHorizontal': false,
      'lightColourVertical': false,
      'lightColourHorizontal': false,
    };
  }

  toggleVerticalSplitterWidth() {
    this.setState({ smallSplitterVertical: !this.state.smallSplitterVertical });
  }

  toggleHorizontalSplitterWidth() {
    this.setState({ smallSplitterHorizontal: !this.state.smallSplitterHorizontal });
  }

  toggleVerticalColour() {
    this.setState({ lightColourVertical: !this.state.lightColourVertical });
  }

  toggleHorizontalColour() {
    this.setState({ lightColourHorizontal: !this.state.lightColourHorizontal });
  }

  render() {
      return (
          <section className="is-styleguide"><a className="anchor" id="splitpanel"></a>

          <h2>Resizeable Split Layout</h2>
          <DarkThemeNav anchor="splitPanels" />
          <p>The Split Layout component is intended to be used as a wrapper for scenarios where you wish to resize various components in the UI.
          There are two modes, vertical and horizontal, and support 2 panels.</p>

          <p>By Default the Split Layout component will work as 2 seperate panels where the main panel will launch the secondary panel when triggered to do so. If you want to avoid this functionality add the <code>split-panel--stacked</code> helper class to the Split Layout parent element and remove the buttons from each panel. You have to set the height of the spllit panels as follows:</p>

          <pre><code className="language-css">{`.split-panel {
  height: 600px;
}
`}</code></pre>

          <p>By default, there will be no gutter on the divider. To enable this, apply <code>split-panel--gutter</code>.</p>

          <p>To enable a colour version apply <code>split-panel--light</code>. Add the following CSS using your own colour for background and box shadow. This can be seen in action by toggling the colour version.</p>

          <pre><code className="language-css">{`.split-panel--light {
  background-color: INSERT-COLOUR-HERE;
}
.split-panel--light.split-panel--gutter .split-panel--vertical--divider,
.split-panel--light.split-panel--gutter .split-panel--horizontal--divider {
  box-shadow: 0 0 0 12px INSERT-COLOUR-HERE;
}`}</code></pre>

          <br/>

          <h3>Vertical Layout</h3>

          <p>You can use a vertical splitter - this can be achieved by adding the
          <code> js-vertically-divided</code> JavaScript hook to the container.</p>

          <button className="btn push--right push--bottom" onClick={this.toggleVerticalColour.bind(this)}>Toggle Colour Version</button>
          <button className="btn push--right push--bottom" onClick={this.toggleVerticalSplitterWidth.bind(this)}>Toggle Splitter Width</button>

          <div className={`split-panel split-panel--vertical split-panel--gutter js-split-panel js-vertically-divided ${ this.state.smallSplitterVertical && 'split-panel--vertical-small' } ${ this.state.lightColourVertical && 'split-panel--light' }`}>
              <div className="soft-half split-panel--main">
                <div>
                  <h1>Content Main</h1>
                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam dapibus scelerisque mi, at ultrices lacus. Praesent eget dolor sit amet lorem porta tempor. Vestibulum ut nisl euismod, viverra ante posuere, lobortis sem. Morbi aliquet libero vel accumsan vulputate. Nullam tincidunt tellus et dui tempus dapibus congue sit amet tellus. Vestibulum diam massa, fermentum eget lobortis ac, venenatis ut orci. Donec in feugiat lacus. Pellentesque lobortis arcu vehicula, mattis dui id, pharetra enim. Fusce consectetur ac erat et convallis. Cras lorem massa, egestas quis pretium in, pellentesque sed ipsum. Sed rhoncus erat dignissim nulla placerat sodales. Duis vel blandit turpis. Sed semper tellus velit, iaculis aliquet velit porta vitae.</p>
                  <p>Integer ac commodo neque. Vestibulum a elit id ligula eleifend gravida commodo ac ligula. Nam congue eget urna elementum consequat. Pellentesque faucibus sagittis lacinia. Sed rhoncus tincidunt felis sagittis feugiat. Quisque ullamcorper ipsum vitae molestie pulvinar. Sed eget consectetur nisl. Etiam rhoncus, purus vel lacinia commodo, orci velit posuere nisi, eget venenatis metus est sit amet turpis.</p>
                  <p>Duis porta ultricies mi, eu malesuada eros ullamcorper nec. Etiam a justo scelerisque, posuere est nec, facilisis lorem. Nam non felis et nulla suscipit sodales sed finibus lacus. In auctor non magna ut dignissim. Praesent nec sodales velit, eget condimentum tellus. In hac habitasse platea dictumst. Aenean nec est accumsan ipsum venenatis vehicula. Nulla nec risus non turpis placerat accumsan. Quisque id enim interdum eros egestas accumsan. Pellentesque quis diam porttitor, dignissim leo eget, pretium velit.</p>
                  <p>Nulla facilisi. Proin accumsan maximus lectus, sed aliquet justo iaculis lobortis. Praesent tincidunt bibendum neque, nec laoreet enim accumsan sit amet. Morbi efficitur nec turpis id feugiat. Vivamus condimentum bibendum venenatis. Suspendisse nulla mi, sollicitudin ut vehicula nec, lacinia quis ante. Nunc vel consectetur nisi. In placerat lacinia auctor. Morbi ultricies bibendum massa, id aliquam magna commodo non. Nulla iaculis sem sed erat congue, vel cursus ipsum cursus. Maecenas congue hendrerit vulputate. Duis dapibus velit at dictum dictum.</p>
                  <button className="btn split-panel--btn split-panel__launch">Launch Content</button>
                </div>
              </div>
              <div className="soft-half split-panel--secondary">
                <div className="soft-half split-panel--title">
                  <i className="fa fa-angle-left split-panel__back"></i>
                  <h1>Content Two</h1>
                </div>
                <table className="table table--light table--comfy table--hover table--striped table--responsive js-table--responsive">
                  <thead>
                    <tr>
                      <th>Lorem</th>
                      <th>Ipsum</th>
                      <th>Dolor</th>
                      <th>Sit</th>
                      <th>Amet</th>
                      <th>Consectetur</th>
                      <th>Afdipisicing</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="row">
                        <a href="">Sit</a>
                      </th>
                      <td>Dolor</td>
                      <td className="text--center">03.788</td>
                      <td>Lorem</td>
                      <td>Amet</td>
                      <td>Consectetur</td>
                      <td>Afdipisicing</td>
                    </tr>
                    <tr>
                      <th scope="row">
                        <a href="">Sit</a>
                      </th>
                      <td>Dolor</td>
                      <td className="text--center">32.210</td>
                      <td>Lorem</td>
                      <td>Amet</td>
                      <td>Consectetur</td>
                      <td>Afdipisicing</td>
                    </tr>
                    <tr>
                      <th scope="row">
                        <a href="">Sit</a>
                      </th>
                      <td>Dolor</td>
                      <td className="text--center">47.797</td>
                      <td>Lorem</td>
                      <td>Amet</td>
                      <td>Consectetur</td>
                      <td>Afdipisicing</td>
                    </tr>
                    <tr>
                      <th scope="row">
                        <a href="">Sit</a>
                      </th>
                      <td>Dolor</td>
                      <td className="text--center">09.640</td>
                      <td>Lorem</td>
                      <td>Amet</td>
                      <td>Consectetur</td>
                      <td>Afdipisicing</td>
                    </tr>
                    <tr>
                      <th scope="row">
                        <a href="">Sit</a>
                      </th>
                      <td>Dolor</td>
                      <td className="text--center">12.117</td>
                      <td>Lorem</td>
                      <td>Amet</td>
                      <td>Consectetur</td>
                      <td>Afdipisicing</td>
                    </tr>
                  </tbody>
                </table>
              </div>
          </div>

          <br/>

          <h3>Horizontal Layout</h3>

          <p>You can also use a horizontal splitter - this can be achieved by adding the
          <code> js-horizontally-divided</code> JavaScript hook to the container.</p>

          <button className="btn push--right push--bottom" onClick={this.toggleHorizontalColour.bind(this)}>Toggle Colour Version</button>
          <button className="btn push--right push--bottom" onClick={this.toggleHorizontalSplitterWidth.bind(this)}>Toggle Splitter Width</button>

          <div className={`split-panel split-panel--horizontal js-split-panel js-horizontally-divided ${ this.state.smallSplitterHorizontal && 'split-panel--horizontal-small' } ${ this.state.lightColourHorizontal && 'split-panel--light' }`}>
              <div className="soft-half split-panel--main">
                <div>
                  <h1>Content Main</h1>
                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam dapibus scelerisque mi, at ultrices lacus. Praesent eget dolor sit amet lorem porta tempor. Vestibulum ut nisl euismod, viverra ante posuere, lobortis sem. Morbi aliquet libero vel accumsan vulputate. Nullam tincidunt tellus et dui tempus dapibus congue sit amet tellus. Vestibulum diam massa, fermentum eget lobortis ac, venenatis ut orci. Donec in feugiat lacus. Pellentesque lobortis arcu vehicula, mattis dui id, pharetra enim. Fusce consectetur ac erat et convallis. Cras lorem massa, egestas quis pretium in, pellentesque sed ipsum. Sed rhoncus erat dignissim nulla placerat sodales. Duis vel blandit turpis. Sed semper tellus velit, iaculis aliquet velit porta vitae.</p>
                  <p>Integer ac commodo neque. Vestibulum a elit id ligula eleifend gravida commodo ac ligula. Nam congue eget urna elementum consequat. Pellentesque faucibus sagittis lacinia. Sed rhoncus tincidunt felis sagittis feugiat. Quisque ullamcorper ipsum vitae molestie pulvinar. Sed eget consectetur nisl. Etiam rhoncus, purus vel lacinia commodo, orci velit posuere nisi, eget venenatis metus est sit amet turpis.</p>
                  <p>Duis porta ultricies mi, eu malesuada eros ullamcorper nec. Etiam a justo scelerisque, posuere est nec, facilisis lorem. Nam non felis et nulla suscipit sodales sed finibus lacus. In auctor non magna ut dignissim. Praesent nec sodales velit, eget condimentum tellus. In hac habitasse platea dictumst. Aenean nec est accumsan ipsum venenatis vehicula. Nulla nec risus non turpis placerat accumsan. Quisque id enim interdum eros egestas accumsan. Pellentesque quis diam porttitor, dignissim leo eget, pretium velit.</p>
                  <p>Nulla facilisi. Proin accumsan maximus lectus, sed aliquet justo iaculis lobortis. Praesent tincidunt bibendum neque, nec laoreet enim accumsan sit amet. Morbi efficitur nec turpis id feugiat. Vivamus condimentum bibendum venenatis. Suspendisse nulla mi, sollicitudin ut vehicula nec, lacinia quis ante. Nunc vel consectetur nisi. In placerat lacinia auctor. Morbi ultricies bibendum massa, id aliquam magna commodo non. Nulla iaculis sem sed erat congue, vel cursus ipsum cursus. Maecenas congue hendrerit vulputate. Duis dapibus velit at dictum dictum.</p>
                  <button className="btn split-panel--btn split-panel__launch">Launch Content</button>
                </div>
              </div>
              <div className="soft-half split-panel--secondary">
                <div className="soft-half split-panel--title">
                  <i className="fa fa-angle-left split-panel__back"></i>
                  <h1>Content Two</h1>
                </div>
                <table className="table table--light table--comfy table--hover table--striped table--responsive js-table--responsive">
                  <thead>
                    <tr>
                      <th>Lorem</th>
                      <th>Ipsum</th>
                      <th>Dolor</th>
                      <th>Sit</th>
                      <th>Amet</th>
                      <th>Consectetur</th>
                      <th>Afdipisicing</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="row">
                        <a href="">Sit</a>
                      </th>
                      <td>Dolor</td>
                      <td className="text--center">03.788</td>
                      <td>Lorem</td>
                      <td>Amet</td>
                      <td>Consectetur</td>
                      <td>Afdipisicing</td>
                    </tr>
                    <tr>
                      <th scope="row">
                        <a href="">Sit</a>
                      </th>
                      <td>Dolor</td>
                      <td className="text--center">32.210</td>
                      <td>Lorem</td>
                      <td>Amet</td>
                      <td>Consectetur</td>
                      <td>Afdipisicing</td>
                    </tr>
                    <tr>
                      <th scope="row">
                        <a href="">Sit</a>
                      </th>
                      <td>Dolor</td>
                      <td className="text--center">47.797</td>
                      <td>Lorem</td>
                      <td>Amet</td>
                      <td>Consectetur</td>
                      <td>Afdipisicing</td>
                    </tr>
                    <tr>
                      <th scope="row">
                        <a href="">Sit</a>
                      </th>
                      <td>Dolor</td>
                      <td className="text--center">09.640</td>
                      <td>Lorem</td>
                      <td>Amet</td>
                      <td>Consectetur</td>
                      <td>Afdipisicing</td>
                    </tr>
                    <tr>
                      <th scope="row">
                        <a href="">Sit</a>
                      </th>
                      <td>Dolor</td>
                      <td className="text--center">12.117</td>
                      <td>Lorem</td>
                      <td>Amet</td>
                      <td>Consectetur</td>
                      <td>Afdipisicing</td>
                    </tr>
                  </tbody>
                </table>
              </div>
          </div>

          <br/>

        <div className="callout">
            <strong>Note:</strong> The height of the Split Layout wrapper, <code>.split-panel</code>, must be determined by the developer due to the panels being absolutely positioned and not inheriting height.
        </div>

        <br />

          <p>The JavaScript event <code>'resized.commonui.splitpanel'</code> will get triggered on the element once the user
          has finished dragging the splitter. You can listen to this event like so:</p>

          <pre>
              <code className="language-js">{`for (const splitPanel of document.getElementsByClassName('js-split-panel')) {
  splitPanel.addEventListener('resized.commonui.splitpanel', () => {}, false);
}`}</code></pre>

          <br/>

          <p>Click 'View Source' to show the code for all 4 different Split Layout Options.</p>

          <button type="button" className="btn btn--secondary show-code">
          <i className="fa fa-plus"></i>View source</button>
          <br/><br/>
          <pre className="hide-code">
         <code className="language-html">{`<div class="split-panel split-panel--vertical js-split-panel js-vertically-divided">
  <div class="split-panel--main">
    <div>
      <h1>Vertical One</h1>
      <p>This is Panel 1.</p>
      <button class="btn split-panel--btn split-panel__launch">Launch Panel</button>
    </div>
  </div>
  <div class="split-panel--secondary">
    <div class="soft-half split-panel--title">
      <i class="fa fa-angle-left split-panel__back"></i>
      <h1>Vertical Two</h1>
    </div>
    <p>This is Panel 2.</p>
  </div>
</div>

<div class="split-panel split-panel--horizontal js-split-panel js-horizontally-divided">
  <div class="split-panel--main">
    <div>
      <h1>Horizontal One</h1>
      <p>This is Panel 1.</p>
      <button class="btn split-panel--btn split-panel__launch">Launch Panel</button>
    </div>
  </div>
  <div class="split-panel--secondary">
    <div class="soft-half split-panel--title">
      <i class="fa fa-angle-left split-panel__back"></i>
      <h1>Horizontal Two</h1>
    </div>
    <p>This is Panel 2.</p>
  </div>
</div>

<div class="split-panel split-panel--stacked split-panel--vertical js-split-panel js-vertically-divided">
  <div class="split-panel--main">
    <div>
      <h1>Vertical One Stacked</h1>
      <p>This is Panel 1.</p>
    </div>
  </div>
  <div class="split-panel--secondary">
    <h1>Vertical Two Stacked</h2>
    <p>This is Panel 2.</p>
  </div>
</div>

<div class="split-panel split-panel--stacked split-panel--horizontal js-split-panel js-horizontally-divided">
  <div class="split-panel--main">
    <div>
      <h1>Horizontal One Stacked</h1>
      <p>This is Panel 1.</p>
    </div>
  </div>
  <div class="split-panel--secondary">
    <h1>Horizontal Two Stacked</h1>
    <p>This is Panel 2.</p>
  </div>
</div>`}</code></pre>

        <br/>

        <h3>Responsive Default Vertical</h3>
        <p>At the smallest breakpoint, the panels will stack and the splitter will be removed. This is reset when back at the larger breakpoints.</p>
        <select className="size-select">
            <option value="auto">Select a resolution</option>
            <option value="480">480px (xs)</option>
            <option value="768">768px (sm)</option>
            <option value="992">992px (md)</option>
            <option value="1200">1200px (lg)</option>
        </select>
        <br/><br/>
        <div className="iframe-container" style={{"height":"600px"}}>
        <iframe seamless srcDoc={`<html>
  <head>
    <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">
    <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css">
    <link rel="stylesheet" type="text/css" href="//fonts.googleapis.com/css?family=Roboto">
    <link rel="stylesheet" type="text/css" href="css/commonUI.css">
    <link rel="stylesheet" type="text/css" href="css/styleguide.css">
  </head>
  <body class="is-styleguide">
    <div class="split-panel split-panel--vertical js-split-panel js-vertically-divided">
        <div class="soft-half split-panel--main">
          <div>
            <h1>Content Main</h1>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam dapibus scelerisque mi, at ultrices lacus. Praesent eget dolor sit amet lorem porta tempor. Vestibulum ut nisl euismod, viverra ante posuere, lobortis sem. Morbi aliquet libero vel accumsan vulputate. Nullam tincidunt tellus et dui tempus dapibus congue sit amet tellus. Vestibulum diam massa, fermentum eget lobortis ac, venenatis ut orci. Donec in feugiat lacus. Pellentesque lobortis arcu vehicula, mattis dui id, pharetra enim. Fusce consectetur ac erat et convallis. Cras lorem massa, egestas quis pretium in, pellentesque sed ipsum. Sed rhoncus erat dignissim nulla placerat sodales. Duis vel blandit turpis. Sed semper tellus velit, iaculis aliquet velit porta vitae.</p>
            <p>Integer ac commodo neque. Vestibulum a elit id ligula eleifend gravida commodo ac ligula. Nam congue eget urna elementum consequat. Pellentesque faucibus sagittis lacinia. Sed rhoncus tincidunt felis sagittis feugiat. Quisque ullamcorper ipsum vitae molestie pulvinar. Sed eget consectetur nisl. Etiam rhoncus, purus vel lacinia commodo, orci velit posuere nisi, eget venenatis metus est sit amet turpis.</p>
            <p>Duis porta ultricies mi, eu malesuada eros ullamcorper nec. Etiam a justo scelerisque, posuere est nec, facilisis lorem. Nam non felis et nulla suscipit sodales sed finibus lacus. In auctor non magna ut dignissim. Praesent nec sodales velit, eget condimentum tellus. In hac habitasse platea dictumst. Aenean nec est accumsan ipsum venenatis vehicula. Nulla nec risus non turpis placerat accumsan. Quisque id enim interdum eros egestas accumsan. Pellentesque quis diam porttitor, dignissim leo eget, pretium velit.</p>
            <p>Nulla facilisi. Proin accumsan maximus lectus, sed aliquet justo iaculis lobortis. Praesent tincidunt bibendum neque, nec laoreet enim accumsan sit amet. Morbi efficitur nec turpis id feugiat. Vivamus condimentum bibendum venenatis. Suspendisse nulla mi, sollicitudin ut vehicula nec, lacinia quis ante. Nunc vel consectetur nisi. In placerat lacinia auctor. Morbi ultricies bibendum massa, id aliquam magna commodo non. Nulla iaculis sem sed erat congue, vel cursus ipsum cursus. Maecenas congue hendrerit vulputate. Duis dapibus velit at dictum dictum.</p>
            <button class="btn split-panel--btn split-panel__launch">Launch Content</button>
          </div>
        </div>
        <div class="split-panel--secondary">
            <div class="soft-half split-panel--title">
              <i class="fa fa-angle-left split-panel__back"></i>
              <h1>Content Secondary</h1>
            </div>
            <div class="soft-half">
            <table class="table table--light table--comfy table--hover table--striped table--responsive js-table--responsive">
            <thead>
              <tr>
                <th>Lorem</th>
                <th>Ipsum</th>
                <th>Dolor</th>
                <th>Sit</th>
                <th>Amet</th>
                <th>Consectetur</th>
                <th>Afdipisicing</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th scope="row">
                  <a href="">Sit</a>
                </th>
                <td>Dolor</td>
                <td class="text--center">03.788</td>
                <td>Lorem</td>
                <td>Amet</td>
                <td>Consectetur</td>
                <td>Afdipisicing</td>
              </tr>
              <tr>
                <th scope="row">
                  <a href="">Sit</a>
                </th>
                <td>Dolor</td>
                <td class="text--center">32.210</td>
                <td>Lorem</td>
                <td>Amet</td>
                <td>Consectetur</td>
                <td>Afdipisicing</td>
              </tr>
              <tr>
                <th scope="row">
                  <a href="">Sit</a>
                </th>
                <td>Dolor</td>
                <td class="text--center">47.797</td>
                <td>Lorem</td>
                <td>Amet</td>
                <td>Consectetur</td>
                <td>Afdipisicing</td>
              </tr>
              <tr>
                <th scope="row">
                  <a href="">Sit</a>
                </th>
                <td>Dolor</td>
                <td class="text--center">09.640</td>
                <td>Lorem</td>
                <td>Amet</td>
                <td>Consectetur</td>
                <td>Afdipisicing</td>
              </tr>
              <tr>
                <th scope="row">
                  <a href="">Sit</a>
                </th>
                <td>Dolor</td>
                <td class="text--center">12.117</td>
                <td>Lorem</td>
                <td>Amet</td>
                <td>Consectetur</td>
                <td>Afdipisicing</td>
              </tr>
            </tbody>
            </table>
            </div>
        </div>
    </div>
  </body>
  <script type="text/javascript" src="js/commonUI.js"></script>
  <script>
    function init() {
      commonUI.initializeTable();
      commonUI.initializeSplitPanel();
    }
    window.onload = init;
  </script>
</html>`}></iframe>
        </div>

        <br/>
        <h3>Responsive Default Horizontal</h3>
        <p>At the smallest breakpoint, the panels will stack and the splitter will be removed. This is reset when back at the larger breakpoints.</p>
        <select className="size-select">
            <option value="auto">Select a resolution</option>
            <option value="480">480px (xs)</option>
            <option value="768">768px (sm)</option>
            <option value="992">992px (md)</option>
            <option value="1200">1200px (lg)</option>
        </select>
        <br/><br/>
        <div className="iframe-container" style={{"height":"600px"}}>
        <iframe seamless srcDoc={`<html>
  <head>
    <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">
    <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css">
    <link rel="stylesheet" type="text/css" href="//fonts.googleapis.com/css?family=Roboto">
    <link rel="stylesheet" type="text/css" href="css/commonUI.css">
    <link rel="stylesheet" type="text/css" href="css/styleguide.css">
  </head>
  <body class="is-styleguide">
    <div class="split-panel split-panel--horizontal js-split-panel js-horizontally-divided">
        <div class="soft-half split-panel--main">
          <div>
            <h1>Content Main</h1>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam dapibus scelerisque mi, at ultrices lacus. Praesent eget dolor sit amet lorem porta tempor. Vestibulum ut nisl euismod, viverra ante posuere, lobortis sem. Morbi aliquet libero vel accumsan vulputate. Nullam tincidunt tellus et dui tempus dapibus congue sit amet tellus. Vestibulum diam massa, fermentum eget lobortis ac, venenatis ut orci. Donec in feugiat lacus. Pellentesque lobortis arcu vehicula, mattis dui id, pharetra enim. Fusce consectetur ac erat et convallis. Cras lorem massa, egestas quis pretium in, pellentesque sed ipsum. Sed rhoncus erat dignissim nulla placerat sodales. Duis vel blandit turpis. Sed semper tellus velit, iaculis aliquet velit porta vitae.</p>
            <p>Integer ac commodo neque. Vestibulum a elit id ligula eleifend gravida commodo ac ligula. Nam congue eget urna elementum consequat. Pellentesque faucibus sagittis lacinia. Sed rhoncus tincidunt felis sagittis feugiat. Quisque ullamcorper ipsum vitae molestie pulvinar. Sed eget consectetur nisl. Etiam rhoncus, purus vel lacinia commodo, orci velit posuere nisi, eget venenatis metus est sit amet turpis.</p>
            <p>Duis porta ultricies mi, eu malesuada eros ullamcorper nec. Etiam a justo scelerisque, posuere est nec, facilisis lorem. Nam non felis et nulla suscipit sodales sed finibus lacus. In auctor non magna ut dignissim. Praesent nec sodales velit, eget condimentum tellus. In hac habitasse platea dictumst. Aenean nec est accumsan ipsum venenatis vehicula. Nulla nec risus non turpis placerat accumsan. Quisque id enim interdum eros egestas accumsan. Pellentesque quis diam porttitor, dignissim leo eget, pretium velit.</p>
            <p>Nulla facilisi. Proin accumsan maximus lectus, sed aliquet justo iaculis lobortis. Praesent tincidunt bibendum neque, nec laoreet enim accumsan sit amet. Morbi efficitur nec turpis id feugiat. Vivamus condimentum bibendum venenatis. Suspendisse nulla mi, sollicitudin ut vehicula nec, lacinia quis ante. Nunc vel consectetur nisi. In placerat lacinia auctor. Morbi ultricies bibendum massa, id aliquam magna commodo non. Nulla iaculis sem sed erat congue, vel cursus ipsum cursus. Maecenas congue hendrerit vulputate. Duis dapibus velit at dictum dictum.</p>
            <button class="btn split-panel--btn split-panel__launch">Launch Content</button>
          </div>
        </div>
        <div class="split-panel--secondary">
            <div class="soft-half split-panel--title">
              <i class="fa fa-angle-left split-panel__back"></i>
              <h1>Content Secondary</h1>
            </div>
            <div class="soft-half">
            <table class="table table--light table--comfy table--hover table--striped table--responsive js-table--responsive">
            <thead>
              <tr>
                <th>Lorem</th>
                <th>Ipsum</th>
                <th>Dolor</th>
                <th>Sit</th>
                <th>Amet</th>
                <th>Consectetur</th>
                <th>Afdipisicing</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th scope="row">
                  <a href="">Sit</a>
                </th>
                <td>Dolor</td>
                <td class="text--center">03.788</td>
                <td>Lorem</td>
                <td>Amet</td>
                <td>Consectetur</td>
                <td>Afdipisicing</td>
              </tr>
              <tr>
                <th scope="row">
                  <a href="">Sit</a>
                </th>
                <td>Dolor</td>
                <td class="text--center">32.210</td>
                <td>Lorem</td>
                <td>Amet</td>
                <td>Consectetur</td>
                <td>Afdipisicing</td>
              </tr>
              <tr>
                <th scope="row">
                  <a href="">Sit</a>
                </th>
                <td>Dolor</td>
                <td class="text--center">47.797</td>
                <td>Lorem</td>
                <td>Amet</td>
                <td>Consectetur</td>
                <td>Afdipisicing</td>
              </tr>
              <tr>
                <th scope="row">
                  <a href="">Sit</a>
                </th>
                <td>Dolor</td>
                <td class="text--center">09.640</td>
                <td>Lorem</td>
                <td>Amet</td>
                <td>Consectetur</td>
                <td>Afdipisicing</td>
              </tr>
              <tr>
                <th scope="row">
                  <a href="">Sit</a>
                </th>
                <td>Dolor</td>
                <td class="text--center">12.117</td>
                <td>Lorem</td>
                <td>Amet</td>
                <td>Consectetur</td>
                <td>Afdipisicing</td>
              </tr>
            </tbody>
            </table>
            </div>
        </div>
    </div>
  </body>
  <script type="text/javascript" src="js/commonUI.js"></script>
  <script>
    function init() {
        commonUI.initializeTable();
        commonUI.initializeSplitPanel();
    }
    window.onload = init;
  </script>
</html>`}></iframe>
        </div>

        <br/>

        <h3>Responsive Stacked Vertical</h3>
        <p>At the smallest breakpoint, the panels will stack and the splitter will be removed. This is reset when back at the larger breakpoints.</p>
        <select className="size-select">
            <option value="auto">Select a resolution</option>
            <option value="480">480px (xs)</option>
            <option value="768">768px (sm)</option>
            <option value="992">992px (md)</option>
            <option value="1200">1200px (lg)</option>
        </select>
        <br/><br/>
        <div className="iframe-container" style={{"height":"600px"}}>
        <iframe seamless srcDoc={`<html>
  <head>
    <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">
    <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css">
    <link rel="stylesheet" type="text/css" href="//fonts.googleapis.com/css?family=Roboto">
    <link rel="stylesheet" type="text/css" href="css/commonUI.css">
    <link rel="stylesheet" type="text/css" href="css/styleguide.css">
  </head>
  <body class="is-styleguide">
    <div class="split-panel split-panel--vertical split-panel--stacked js-split-panel js-vertically-divided">
        <div class="soft-half split-panel--main">
          <div>
            <h1>Content Main</h1>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam dapibus scelerisque mi, at ultrices lacus. Praesent eget dolor sit amet lorem porta tempor. Vestibulum ut nisl euismod, viverra ante posuere, lobortis sem. Morbi aliquet libero vel accumsan vulputate. Nullam tincidunt tellus et dui tempus dapibus congue sit amet tellus. Vestibulum diam massa, fermentum eget lobortis ac, venenatis ut orci. Donec in feugiat lacus. Pellentesque lobortis arcu vehicula, mattis dui id, pharetra enim. Fusce consectetur ac erat et convallis. Cras lorem massa, egestas quis pretium in, pellentesque sed ipsum. Sed rhoncus erat dignissim nulla placerat sodales. Duis vel blandit turpis. Sed semper tellus velit, iaculis aliquet velit porta vitae.</p>
            <p>Integer ac commodo neque. Vestibulum a elit id ligula eleifend gravida commodo ac ligula. Nam congue eget urna elementum consequat. Pellentesque faucibus sagittis lacinia. Sed rhoncus tincidunt felis sagittis feugiat. Quisque ullamcorper ipsum vitae molestie pulvinar. Sed eget consectetur nisl. Etiam rhoncus, purus vel lacinia commodo, orci velit posuere nisi, eget venenatis metus est sit amet turpis.</p>
            <p>Duis porta ultricies mi, eu malesuada eros ullamcorper nec. Etiam a justo scelerisque, posuere est nec, facilisis lorem. Nam non felis et nulla suscipit sodales sed finibus lacus. In auctor non magna ut dignissim. Praesent nec sodales velit, eget condimentum tellus. In hac habitasse platea dictumst. Aenean nec est accumsan ipsum venenatis vehicula. Nulla nec risus non turpis placerat accumsan. Quisque id enim interdum eros egestas accumsan. Pellentesque quis diam porttitor, dignissim leo eget, pretium velit.</p>
            <p>Nulla facilisi. Proin accumsan maximus lectus, sed aliquet justo iaculis lobortis. Praesent tincidunt bibendum neque, nec laoreet enim accumsan sit amet. Morbi efficitur nec turpis id feugiat. Vivamus condimentum bibendum venenatis. Suspendisse nulla mi, sollicitudin ut vehicula nec, lacinia quis ante. Nunc vel consectetur nisi. In placerat lacinia auctor. Morbi ultricies bibendum massa, id aliquam magna commodo non. Nulla iaculis sem sed erat congue, vel cursus ipsum cursus. Maecenas congue hendrerit vulputate. Duis dapibus velit at dictum dictum.</p>
          </div>
        </div>
        <div class="soft-half split-panel--secondary">
        <h1>Content Secondary</h1>
        <table class="table table--light table--comfy table--hover table--striped table--responsive js-table--responsive">
        <thead>
          <tr>
            <th>Lorem</th>
            <th>Ipsum</th>
            <th>Dolor</th>
            <th>Sit</th>
            <th>Amet</th>
            <th>Consectetur</th>
            <th>Afdipisicing</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="row">
              <a href="">Sit</a>
            </th>
            <td>Dolor</td>
            <td class="text--center">03.788</td>
            <td>Lorem</td>
            <td>Amet</td>
            <td>Consectetur</td>
            <td>Afdipisicing</td>
          </tr>
          <tr>
            <th scope="row">
              <a href="">Sit</a>
            </th>
            <td>Dolor</td>
            <td class="text--center">32.210</td>
            <td>Lorem</td>
            <td>Amet</td>
            <td>Consectetur</td>
            <td>Afdipisicing</td>
          </tr>
          <tr>
            <th scope="row">
              <a href="">Sit</a>
            </th>
            <td>Dolor</td>
            <td class="text--center">47.797</td>
            <td>Lorem</td>
            <td>Amet</td>
            <td>Consectetur</td>
            <td>Afdipisicing</td>
          </tr>
          <tr>
            <th scope="row">
              <a href="">Sit</a>
            </th>
            <td>Dolor</td>
            <td class="text--center">09.640</td>
            <td>Lorem</td>
            <td>Amet</td>
            <td>Consectetur</td>
            <td>Afdipisicing</td>
          </tr>
          <tr>
            <th scope="row">
              <a href="">Sit</a>
            </th>
            <td>Dolor</td>
            <td class="text--center">12.117</td>
            <td>Lorem</td>
            <td>Amet</td>
            <td>Consectetur</td>
            <td>Afdipisicing</td>
          </tr>
        </tbody>
        </table>
        </div>
    </div>
  </body>
  <script type="text/javascript" src="js/commonUI.js"></script>
  <script>
    function init() {
        commonUI.initializeTable();
        commonUI.initializeSplitPanel();
    }
    window.onload = init;
  </script>
</html>`}></iframe>
        </div>

        <br/>

        <h3>Responsive Stacked Horizontal</h3>
        <p>At the smallest breakpoint, the panels will stack and the splitter will be removed. This is reset when back at the larger breakpoints.</p>
        <select className="size-select">
            <option value="auto">Select a resolution</option>
            <option value="480">480px (xs)</option>
            <option value="768">768px (sm)</option>
            <option value="992">992px (md)</option>
            <option value="1200">1200px (lg)</option>
        </select>
        <br/><br/>
        <div className="iframe-container" style={{"height":"600px"}}>
        <iframe seamless srcDoc={`<html>
  <head>
    <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">
    <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css">
    <link rel="stylesheet" type="text/css" href="//fonts.googleapis.com/css?family=Roboto">
    <link rel="stylesheet" type="text/css" href="css/commonUI.css">
    <link rel="stylesheet" type="text/css" href="css/styleguide.css">
  </head>
  <body class="is-styleguide">
    <div class="split-panel split-panel--horizontal split-panel--stacked js-split-panel js-horizontally-divided">
        <div class="soft-half split-panel--main">
          <div>
            <h1>Content Main</h1>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam dapibus scelerisque mi, at ultrices lacus. Praesent eget dolor sit amet lorem porta tempor. Vestibulum ut nisl euismod, viverra ante posuere, lobortis sem. Morbi aliquet libero vel accumsan vulputate. Nullam tincidunt tellus et dui tempus dapibus congue sit amet tellus. Vestibulum diam massa, fermentum eget lobortis ac, venenatis ut orci. Donec in feugiat lacus. Pellentesque lobortis arcu vehicula, mattis dui id, pharetra enim. Fusce consectetur ac erat et convallis. Cras lorem massa, egestas quis pretium in, pellentesque sed ipsum. Sed rhoncus erat dignissim nulla placerat sodales. Duis vel blandit turpis. Sed semper tellus velit, iaculis aliquet velit porta vitae.</p>
            <p>Integer ac commodo neque. Vestibulum a elit id ligula eleifend gravida commodo ac ligula. Nam congue eget urna elementum consequat. Pellentesque faucibus sagittis lacinia. Sed rhoncus tincidunt felis sagittis feugiat. Quisque ullamcorper ipsum vitae molestie pulvinar. Sed eget consectetur nisl. Etiam rhoncus, purus vel lacinia commodo, orci velit posuere nisi, eget venenatis metus est sit amet turpis.</p>
            <p>Duis porta ultricies mi, eu malesuada eros ullamcorper nec. Etiam a justo scelerisque, posuere est nec, facilisis lorem. Nam non felis et nulla suscipit sodales sed finibus lacus. In auctor non magna ut dignissim. Praesent nec sodales velit, eget condimentum tellus. In hac habitasse platea dictumst. Aenean nec est accumsan ipsum venenatis vehicula. Nulla nec risus non turpis placerat accumsan. Quisque id enim interdum eros egestas accumsan. Pellentesque quis diam porttitor, dignissim leo eget, pretium velit.</p>
            <p>Nulla facilisi. Proin accumsan maximus lectus, sed aliquet justo iaculis lobortis. Praesent tincidunt bibendum neque, nec laoreet enim accumsan sit amet. Morbi efficitur nec turpis id feugiat. Vivamus condimentum bibendum venenatis. Suspendisse nulla mi, sollicitudin ut vehicula nec, lacinia quis ante. Nunc vel consectetur nisi. In placerat lacinia auctor. Morbi ultricies bibendum massa, id aliquam magna commodo non. Nulla iaculis sem sed erat congue, vel cursus ipsum cursus. Maecenas congue hendrerit vulputate. Duis dapibus velit at dictum dictum.</p>
          </div>
        </div>
        <div class="soft-half split-panel--secondary">
            <h1>Content Secondary</h1>
            <table class="table table--light table--comfy table--hover table--striped table--responsive js-table--responsive">
              <thead>
                <tr>
                  <th>Lorem</th>
                  <th>Ipsum</th>
                  <th>Dolor</th>
                  <th>Sit</th>
                  <th>Amet</th>
                  <th>Consectetur</th>
                  <th>Afdipisicing</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope="row">
                    <a href="">Sit</a>
                  </th>
                  <td>Dolor</td>
                  <td class="text--center">03.788</td>
                  <td>Lorem</td>
                  <td>Amet</td>
                  <td>Consectetur</td>
                  <td>Afdipisicing</td>
                </tr>
                <tr>
                  <th scope="row">
                    <a href="">Sit</a>
                  </th>
                  <td>Dolor</td>
                  <td class="text--center">32.210</td>
                  <td>Lorem</td>
                  <td>Amet</td>
                  <td>Consectetur</td>
                  <td>Afdipisicing</td>
                </tr>
                <tr>
                  <th scope="row">
                    <a href="">Sit</a>
                  </th>
                  <td>Dolor</td>
                  <td class="text--center">47.797</td>
                  <td>Lorem</td>
                  <td>Amet</td>
                  <td>Consectetur</td>
                  <td>Afdipisicing</td>
                </tr>
                <tr>
                  <th scope="row">
                    <a href="">Sit</a>
                  </th>
                  <td>Dolor</td>
                  <td class="text--center">09.640</td>
                  <td>Lorem</td>
                  <td>Amet</td>
                  <td>Consectetur</td>
                  <td>Afdipisicing</td>
                </tr>
                <tr>
                  <th scope="row">
                    <a href="">Sit</a>
                  </th>
                  <td>Dolor</td>
                  <td class="text--center">12.117</td>
                  <td>Lorem</td>
                  <td>Amet</td>
                  <td>Consectetur</td>
                  <td>Afdipisicing</td>
                </tr>
              </tbody>
            </table>
        </div>
    </div>
  </body>
  <script type="text/javascript" src="js/commonUI.js"></script>
  <script>
    function init() {
        commonUI.initializeTable();
        commonUI.initializeSplitPanel();
    }
    window.onload = init;
  </script>
</html>`}></iframe>
        </div>

        <br/>

        <p>This is a javascript enabled component. You must initialize it using the following snippet:</p>

        <pre><code className="language-javascript">{`commonUI.initializeSplitPanel();`}</code></pre>

        <br/>
        <br/>
        <h2>Interactive Split Layout</h2>
        <h3>Interactive Vertical Split Layout</h3>
        <p>The split panel can be activated by clicking on the link with the open panel class. Normal split layout functionality will resume when open. You can then close the split layout if desired by clicking link with closse class.</p>
        <select className="size-select">
            <option value="auto">Select a resolution</option>
            <option value="480">480px (xs)</option>
            <option value="768">768px (sm)</option>
            <option value="992">992px (md)</option>
            <option value="1200">1200px (lg)</option>
        </select>
        <br/><br/>
        <div className="iframe-container" style={{"height":"600px"}}>
        <iframe seamless srcDoc={`<html>
  <head>
    <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">
    <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css">
    <link rel="stylesheet" type="text/css" href="//fonts.googleapis.com/css?family=Roboto">
    <link rel="stylesheet" type="text/css" href="css/commonUI.css">
    <link rel="stylesheet" type="text/css" href="css/styleguide.css">
  </head>
  <body class="is-styleguide">
    <div class="split-panel split-panel--vertical js-split-panel js-vertically-divided is-vertical is-closable">
        <div class="soft-half split-panel--main">
          <div>
            <h1>Content Main</h1>
            <div class="scroll-container-x">
              <table class="table table--comfy table--hover table--striped table--light">
                <thead>
                  <tr>
                    <th>Lorem</th>
                    <th>Ipsum</th>
                    <th>Dolor</th>
                    <th>Sit</th>
                    <th>Amet</th>
                    <th>Consectetur</th>
                    <th>Afdipisicing</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th scope="row" class="table__cell--highlight"><a class="open-panel" href="javascript:void(0)">Sit</a></th>
                    <td>Dolor</td>
                    <td class="text--center">03.788</td>
                    <td>Lorem</td>
                    <td>Amet</td>
                    <td>Consectetur</td>
                    <td>Afdipisicing</td>
                  </tr>
                  <tr>
                    <th scope="row" class="table__cell--highlight"><a class="open-panel" href="javascript:void(0)">Sit</a></th>
                    <td>Dolor</td>
                    <td class="text--center">32.210</td>
                    <td>Lorem</td>
                    <td>Amet</td>
                    <td>Consectetur</td>
                    <td>Afdipisicing</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="split-panel--secondary">
            <div class="soft-half split-panel--title space-between">
              <h1>Content Secondary</h1>
              <button class="btn btn--link close-panel">
                <i class="fas fa-times"></i> Close
              </button>
            </div>
            <div class="soft-half">
            <table class="table table--light table--comfy table--hover table--striped table--responsive js-table--responsive">
            <thead>
              <tr>
                <th>Lorem</th>
                <th>Ipsum</th>
                <th>Dolor</th>
                <th>Sit</th>
                <th>Amet</th>
                <th>Consectetur</th>
                <th>Afdipisicing</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th scope="row">
                  <a href="">Sit</a>
                </th>
                <td>Dolor</td>
                <td class="text--center">03.788</td>
                <td>Lorem</td>
                <td>Amet</td>
                <td>Consectetur</td>
                <td>Afdipisicing</td>
              </tr>
              <tr>
                <th scope="row">
                  <a href="">Sit</a>
                </th>
                <td>Dolor</td>
                <td class="text--center">32.210</td>
                <td>Lorem</td>
                <td>Amet</td>
                <td>Consectetur</td>
                <td>Afdipisicing</td>
              </tr>
              <tr>
                <th scope="row">
                  <a href="">Sit</a>
                </th>
                <td>Dolor</td>
                <td class="text--center">47.797</td>
                <td>Lorem</td>
                <td>Amet</td>
                <td>Consectetur</td>
                <td>Afdipisicing</td>
              </tr>
              <tr>
                <th scope="row">
                  <a href="">Sit</a>
                </th>
                <td>Dolor</td>
                <td class="text--center">09.640</td>
                <td>Lorem</td>
                <td>Amet</td>
                <td>Consectetur</td>
                <td>Afdipisicing</td>
              </tr>
              <tr>
                <th scope="row">
                  <a href="">Sit</a>
                </th>
                <td>Dolor</td>
                <td class="text--center">12.117</td>
                <td>Lorem</td>
                <td>Amet</td>
                <td>Consectetur</td>
                <td>Afdipisicing</td>
              </tr>
            </tbody>
            </table>
            </div>
        </div>
    </div>
  </body>
  <script type="text/javascript" src="js/commonUI.js"></script>
  <script>
    function init() {
      commonUI.initializeTable();
      commonUI.initializeSplitPanel({
        closePanel: '.close-panel',
        openPanel: '.open-panel',
        vertical: true,
      });
    }
    window.onload = init;
  </script>
</html>`}></iframe>
        </div>
        <br/>
        <p>Click 'View Source' to show the code for Vertical Interactive Split Layout.</p>

          <button type="button" className="btn btn--secondary show-code">
          <i className="fa fa-plus"></i>View source</button>
          <br/><br/>
          <pre className="hide-code">
         <code className="language-html">{`<div class="split-panel split-panel--vertical js-split-panel js-vertically-divided is-vertical is-closable">
  <div class="soft-half split-panel--main">
    <div>
      <h1>Content Main</h1>
      <div class="scroll-container-x">
        <table class="table table--comfy table--hover table--striped table--light">
          <thead>
            <tr>
              <th>Lorem</th>
              <th>Ipsum</th>
              <th>Dolor</th>
              <th>Sit</th>
              <th>Amet</th>
              <th>Consectetur</th>
              <th>Afdipisicing</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th scope="row" class="table__cell--highlight"><a class="open-panel" href="javascript:void(0)">Sit</a></th>
              <td>Dolor</td>
              <td class="text--center">03.788</td>
              <td>Lorem</td>
              <td>Amet</td>
              <td>Consectetur</td>
              <td>Afdipisicing</td>
            </tr>
            <tr>
              <th scope="row" class="table__cell--highlight"><a class="open-panel" href="javascript:void(0)">Sit</a></th>
              <td>Dolor</td>
              <td class="text--center">32.210</td>
              <td>Lorem</td>
              <td>Amet</td>
              <td>Consectetur</td>
              <td>Afdipisicing</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="split-panel--secondary">
    <div class="soft-half split-panel--title space-between">
      <h1>Content Secondary</h1>
      <button class="btn btn--link close-panel">
        <i class="fas fa-times"></i> Close
      </button>
    </div>
    <div class="soft-half">

    </div>
  </div>
</div>`}</code></pre>

         <br/>
         <br/>
        <p>This is a javascript enabled component. You must initialize it using the following snippet:</p>

        <pre><code className="language-javascript">{`commonUI.initializeSplitPanel({
  closePanel: '.close-panel',
  openPanel: '.open-panel',
  vertical: true,
});`}</code></pre>

        <br/>
        <h3>Interactive Horizontal Split Layout</h3>
        <p>The split panel can be activated by clicking on the link with the open panel class. Normal split layout functionality will resume when open. You can then close the split layout if desired by clicking link with closse class.</p>
        <select className="size-select">
            <option value="auto">Select a resolution</option>
            <option value="480">480px (xs)</option>
            <option value="768">768px (sm)</option>
            <option value="992">992px (md)</option>
            <option value="1200">1200px (lg)</option>
        </select>
        <br/><br/>
        <div className="iframe-container" style={{"height":"600px"}}>
        <iframe seamless srcDoc={`<html>
  <head>
    <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">
    <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css">
    <link rel="stylesheet" type="text/css" href="//fonts.googleapis.com/css?family=Roboto">
    <link rel="stylesheet" type="text/css" href="css/commonUI.css">
    <link rel="stylesheet" type="text/css" href="css/styleguide.css">
  </head>
  <body class="is-styleguide">
    <div class="split-panel split-panel--horizontal js-split-panel js-horizontally-divided is-closable">
      <div class="soft-half split-panel--main">
        <div>
          <h1>Content Main</h1>
          <div class="scroll-container-x">
            <table class="table table--comfy table--hover table--striped table--light">
              <thead>
                <tr>
                  <th>Lorem</th>
                  <th>Ipsum</th>
                  <th>Dolor</th>
                  <th>Sit</th>
                  <th>Amet</th>
                  <th>Consectetur</th>
                  <th>Afdipisicing</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope="row" class="table__cell--highlight"><a class="open-panel" href="javascript:void(0)">Sit</a></th>
                  <td>Dolor</td>
                  <td class="text--center">03.788</td>
                  <td>Lorem</td>
                  <td>Amet</td>
                  <td>Consectetur</td>
                  <td>Afdipisicing</td>
                </tr>
                <tr>
                  <th scope="row" class="table__cell--highlight"><a class="open-panel" href="javascript:void(0)">Sit</a></th>
                  <td>Dolor</td>
                  <td class="text--center">32.210</td>
                  <td>Lorem</td>
                  <td>Amet</td>
                  <td>Consectetur</td>
                  <td>Afdipisicing</td>
                </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
        <div class="split-panel--secondary">
          <div class="soft-half split-panel--title space-between">
            <h1>Content Secondary</h1>
            <button class="btn btn--link close-panel">
              <i class="fas fa-times"></i> Close
            </button>
          </div>
            <div class="soft-half">
            <table class="table table--light table--comfy table--hover table--striped table--responsive js-table--responsive">
            <thead>
              <tr>
                <th>Lorem</th>
                <th>Ipsum</th>
                <th>Dolor</th>
                <th>Sit</th>
                <th>Amet</th>
                <th>Consectetur</th>
                <th>Afdipisicing</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th scope="row">
                  <a href="">Sit</a>
                </th>
                <td>Dolor</td>
                <td class="text--center">03.788</td>
                <td>Lorem</td>
                <td>Amet</td>
                <td>Consectetur</td>
                <td>Afdipisicing</td>
              </tr>
              <tr>
                <th scope="row">
                  <a href="">Sit</a>
                </th>
                <td>Dolor</td>
                <td class="text--center">32.210</td>
                <td>Lorem</td>
                <td>Amet</td>
                <td>Consectetur</td>
                <td>Afdipisicing</td>
              </tr>
              <tr>
                <th scope="row">
                  <a href="">Sit</a>
                </th>
                <td>Dolor</td>
                <td class="text--center">47.797</td>
                <td>Lorem</td>
                <td>Amet</td>
                <td>Consectetur</td>
                <td>Afdipisicing</td>
              </tr>
              <tr>
                <th scope="row">
                  <a href="">Sit</a>
                </th>
                <td>Dolor</td>
                <td class="text--center">09.640</td>
                <td>Lorem</td>
                <td>Amet</td>
                <td>Consectetur</td>
                <td>Afdipisicing</td>
              </tr>
              <tr>
                <th scope="row">
                  <a href="">Sit</a>
                </th>
                <td>Dolor</td>
                <td class="text--center">12.117</td>
                <td>Lorem</td>
                <td>Amet</td>
                <td>Consectetur</td>
                <td>Afdipisicing</td>
              </tr>
            </tbody>
            </table>
            </div>
        </div>
    </div>
  </body>
  <script type="text/javascript" src="js/commonUI.js"></script>
  <script>
    function init() {
        commonUI.initializeTable();
        commonUI.initializeSplitPanel({
          closePanel: '.close-panel',
          openPanel: '.open-panel',
          horizontal: true,
        });
    }
    window.onload = init;
  </script>
</html>`}></iframe>
        </div>
        <br/>
        <p>Click 'View Source' to show the code for Interactive Horizontal Split Layout.</p>

          <button type="button" className="btn btn--secondary show-code">
          <i className="fa fa-plus"></i>View source</button>
          <br/><br/>
          <pre className="hide-code">
         <code className="language-html">{`<div class="split-panel split-panel--horizontal js-split-panel js-horizontally-divided is-closable">
    <div class="soft-half split-panel--main">
      <div>
        <h1>Content Main</h1>
        <div class="scroll-container-x">
          <table class="table table--comfy table--hover table--striped table--light">
            <thead>
              <tr>
                <th>Lorem</th>
                <th>Ipsum</th>
                <th>Dolor</th>
                <th>Sit</th>
                <th>Amet</th>
                <th>Consectetur</th>
                <th>Afdipisicing</th>
              </tr>
            </thead>
          <tbody>
            <tr>
              <th scope="row" class="table__cell--highlight"><a class="open-panel" href="javascript:void(0)">Sit</a></th>
                <td>Dolor</td>
                <td class="text--center">03.788</td>
                <td>Lorem</td>
                <td>Amet</td>
                <td>Consectetur</td>
                <td>Afdipisicing</td>
            </tr>
            <tr>
              <th scope="row" class="table__cell--highlight"><a class="open-panel" href="javascript:void(0)">Sit</a></th>
                <td>Dolor</td>
                <td class="text--center">32.210</td>
                <td>Lorem</td>
                <td>Amet</td>
                <td>Consectetur</td>
                <td>Afdipisicing</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="split-panel--secondary">
    <div class="soft-half split-panel--title space-between">
      <h1>Content Secondary</h1>
      <button class="btn btn--link close-panel">
        <i class="fas fa-times"></i> Close
      </button>
    </div>
    <div class="soft-half">
      <p>Secondary Panel Content</p>
    </div>
  </div>
</div>`}</code></pre>

        <br/>
        <p>This is a javascript enabled component. You must initialize it using the following snippet:</p>

        <pre><code className="language-javascript">{`commonUI.initializeSplitPanel({
  closePanel: '.close-panel',
  openPanel: '.open-panel',
  horizontal: true,
});`}</code></pre>
        <br/>

        <br/><br/>

        <hr/>
      </section>
      );
  }
}

export default SplitPanel;



// WEBPACK FOOTER //
// ./styleguide/components/sections/SplitPanel.js